import { set } from "@/utils/vuex";

export default {
  resetState(state) {
    if (state) {
      Object.assign(state, state.getDefaultState());
    }
  },
  setCustomer: set("userCS"),
  setLoading: set("loading"),
  setUserNotFound: set("userCSNotFound"),
  setUserCSError: set("userCSError"),
  setConsumerUnits: set("consumerUnits"),
  setConsumerUnitsOpened: set("setConsumerUnitsOpened"),
  addConsumerUnitsOpened(state, payload) {
    // console.log('payload: ', payload)
    state.consumerUnitsOpened.unshift(payload);
    // console.log('state.consumerUnitsOpened after: ', state.consumerUnitsOpened)
  },
  setConsumerUnit: set("consumerUnit"),
  setBillings: set("billings"),
  setSpecialBillings: set("specialBillings"),
  setProvisionedBillings: set("provisionedBillings"),
  setBilling: set("billing"),
  setHistory: set("history"),
  setActiveBilling: set("activeBilling"),
  setLoadingBillingCS: set("loadingBillingCS"),
  setObservation: set("observation"),
  setObservations: set("observations"),
  setTask: set("task"),
  setTasks: set("tasks"),
  setAgents: set("agents"),
  setActivities: set("activities"),
  setFilter: set("filter"),
  setNegativations: set("negativations"),
  setNegativation: set("negativation"),
  setOverdue: set("overdue"),
  setCards: set("cards"),
  setLoadingCards: set("loadingCards"),
  setActiveCards: set("activeCards"),
  setContracts: set("contracts"),
  setAccountBalanceHistory: set("accountBalanceHistory"),
  setDocuments: set("documents"),

  pushContract(state, data) {
    state.contracts.push(data);
  },
  spliceContracts(state, { index, data }) {
    state.contracts.splice(index, 1, data);
  },
  pushAccountBalanceHistory(state, data) {
    state.accountBalanceHistory.push(data);
  },
  setReferrals: set("referrals"),

  pushReferral(state, data) {
    state.referrals.push(data);
  },

  pushDocument(state, data) {
    state.documents.push(data);
  },

  spliceReferral(state, { index, data }) {
    state.referrals.splice(index, 1, data);
  },
};
